<template>
    <div>
        <label class="label label-mb4" :class="['', $style.participantIndex]">{{`PARTICIPANT `+ indexToDisplay}}</label>
        <div class="columns">
            <div class="column is-4 padding-right4">
                <b-field label="Email" :class="$style.bField">
                    <b-input type="email"
                             v-model="dirtyEmail"
                             placeholder="Email Address"
                    >
                    </b-input>
                </b-field>
            </div>
            <div class="column padding-right4 padding-left4 color-dropdown-placeholder">
                <b-field label="Role">
                    <b-dropdown
                        v-model="dirtyRole"
                        aria-role="list"
                        class="participant-rowField-container"
                    >
                        <button class="button is-primary role-select-button" slot="trigger">
                            <span class="text-input">
                                {{ dirtyRole !== '' ? dirtyRole : 'Select Role' }}
                            </span>
                            <b-icon type="is-black" icon="menu-down" size="is-small"></b-icon>
                        </button>

                        <b-dropdown-item value="Data Collector" class="role-container-item text-size-body">Data Collector</b-dropdown-item>
                        <hr class="mid-dark margin-none">
                        <b-dropdown-item value="Project Coordinator" class="role-container-item text-size-body">Project Coordinator</b-dropdown-item>
                    </b-dropdown>
                </b-field>
            </div>
            <div class="column padding-left4 padding-right4">
                <b-field label="Site">
                    <b-dropdown
                        v-model="dirtySites"
                        multiple
                        aria-role="list"
                        class="participant-rowField-container"
                    >
                        <button class="button is-primary multi-select-button" type="button" slot="trigger">
                            <span class="text-input">
                                {{ dirtySites[0]
                                    ? (dirtySites.length === localSelectedSiteArray.length ? 'All Sites' : `Selected Sites (${dirtySites.length})`)
                                    : 'Select Sites'
                                }}
                            </span>
                            <b-icon type="is-black" icon="menu-down" size="is-small"></b-icon>
                        </button>

                        <b-dropdown-item
                            value="All Sites"
                            class="dropdown-checkbox all-sites-item"
                            :custom="true"
                        >
                            <div class="checkbox-container">
                                <div class="column is-1 input-container">
                                    <input
                                        type="checkbox"
                                        value="All Sites"
                                        @change="updateSelection"
                                        v-model="dirtyAllSiteFlag"
                                    >
                                </div>
                                <div @click="dropdownAllSitesItemClick('All Sites')" class="column label-container">
                                    <label 
                                        class="break-next-line text-size-body width-full bold color-bold-text"
                                        :class="$style.applyMargin"
                                    >
                                        All Sites
                                    </label>
                                </div>
                            </div>
                            <hr class="mid-dark margin-none">
                        </b-dropdown-item>

                        <b-dropdown-item
                            :value="value.name"
                            aria-role="listitem"
                            v-for="(value, index) in localSelectedSiteArray"
                            :key="index"
                            class="dropdown-checkbox"
                            :custom="true"
                        >
                            <div class="checkbox-container">
                                <div class="column is-1 input-container">
                                    <input
                                        type="checkbox"
                                        :value="value.name"
                                        @change="updateSelection"
                                        v-model="dirtySiteFlag"
                                    >
                                </div>
                                <div @click="dropdownItemClick(value)" class="column label-container">
                                    <label class="break-next-line text-size-body">
                                        <span class="break-next-line text-size-body width-full margin-bottom5">{{value.name}}</span>
                                        <span class="break-next-line text-size width-full color-subheading">{{value.address}}</span>
                                    </label>
                                </div>
                            </div>
                            <hr class="mid-dark margin-none">
                        </b-dropdown-item>
                    </b-dropdown>
                </b-field>
            </div>
            <div class="column is-1 padding-left4">
                <a :class="$style.deletebtn" @click="removeParticipant" v-if="localParticipantList.length !== 1">
                    <b-icon
                            icon="delete"
                    ></b-icon>
                </a>
                <a :class="$style.deletebtn" v-else>
                    <b-icon></b-icon>
                </a>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
    import {Site} from '@/store/modules/projects/types/projects.types';
    import { cloneDeep as _cloneDeep, map as _map } from 'lodash';
    import {isDifferent} from '@/jbi-shared/util/watcher.vue-decorator';

    @Component({ components : {} })

    export default class ParticipantInputs extends Vue {
        @Prop()
        public localParticipantList !: any[];
        @Prop()
        public participantIndex !: number;
        @Prop()
        public localSelectedSiteArray !: Site[];

        public dirtyEmail: string = '';
        public dirtyRole: string | null = null;
        public dirtySites: any[] = [];
        public dirtyParticipantList!: any[];
        public dirtyAllSiteFlag: boolean = true;
        public dirtySiteFlag: string[] = [];

        public updateSelection(event: any) {
            const value = event.target.value;
            const isChecked = event.target.checked;

            if (value === 'All Sites') {
                if (isChecked) {
                    this.dirtySites = [];
                    this.dirtySiteFlag = [];
                    this.localSelectedSiteArray.map((temp: Site) => {
                        this.dirtySiteFlag.push(temp.name);
                        this.dirtySites.push(temp.name);
                    });
                } else {
                    this.dirtySites = [];
                    this.dirtySiteFlag = [];
                }
            } else {
                this.dirtyAllSiteFlag = false;
                if (isChecked) {
                    this.dirtySites.push(value);
                    if (this.dirtySites.length === this.localSelectedSiteArray.length) {
                        this.dirtyAllSiteFlag = true;
                    }
                } else {
                    this.dirtySites = this.dirtySites.filter((elem) => elem !== value);
                }
            }
        }

        public mounted() {
            this.populateData();
        }

        public populateData() {

            if (this.localParticipantList[this.participantIndex] !== undefined) {
                this.dirtyEmail = this.localParticipantList[this.participantIndex].email;
                this.dirtyRole = this.localParticipantList[this.participantIndex].role;
                if (this.dirtyEmail === '') {
                    this.localParticipantList[this.participantIndex].sites.map((temp: Site) => {
                        this.dirtySiteFlag.push(temp.name);
                        this.dirtySites.push(temp.name);
                    });
                } else {
                    const dirtyIndex = this.participantIndex;
                    if (this.localParticipantList[dirtyIndex].sites.length === this.localSelectedSiteArray.length) {
                        this.localSelectedSiteArray.map((temp: Site) => {
                            this.dirtySiteFlag.push(temp.name);
                            this.dirtySites.push(temp.name);
                        });
                        this.dirtyAllSiteFlag = true;
                    } else {
                        this.dirtySites = this.localParticipantList[this.participantIndex].sites.map((x: Site) => x.name);
                        this.dirtyAllSiteFlag = false;
                        this.dirtySiteFlag = _cloneDeep(this.dirtySites);
                    }
                }
            }
        }

        get siteOptions() {
            return this.localSelectedSiteArray;
        }

        @isDifferent
        @Watch('localSelectedSiteArray')
        public watchLocalSelectedSiteArray(newValue: string) {
            this.localSelectedSiteArray.map((temp: Site) => {
                if (!this.dirtySites.includes(temp.name)) {
                    this.dirtySites.push(temp.name);
                }
                if (!this.dirtySiteFlag.includes(temp.name)) {
                    this.dirtySiteFlag.push(temp.name);
                }
            });
        }

        @isDifferent
        @Watch('dirtyEmail')
        public watchDirtyEmail(newValue: string) {
            this.emitParticipantList();
        }

        @isDifferent
        @Watch('dirtyRole')
        public watchDirtyRole(newValue: string) {
            this.emitParticipantList();
        }

        @Watch('dirtySites')
        public watchDirtySites(newValue: any) {
            this.emitParticipantList();
        }

        public emitParticipantList() {
            this.dirtyParticipantList = _cloneDeep(this.localParticipantList);
            let dirtySelectedSites = [];
            if (this.dirtySites.length === this.localSelectedSiteArray.length) {
                dirtySelectedSites = this.localSelectedSiteArray;
            } else {
                dirtySelectedSites = this.localSelectedSiteArray.filter((temp) => this.dirtySites.includes(temp.name));
            }
            if (this.dirtyEmail.trim() && this.dirtyRole && this.dirtyRole.trim()) {
                this.dirtyParticipantList[this.participantIndex] = {
                    email: this.dirtyEmail,
                    role: this.dirtyRole,
                    sites: dirtySelectedSites,
                };
                this.$emit('updateInviteUserArray', this.dirtyParticipantList);
            }
        }

        get indexToDisplay() {
            return this.participantIndex + 1;
        }

        public removeParticipant() {
            this.$emit('removeSelectedParticipant', this.participantIndex);
        }

        public dropdownItemClick(dirtyValue: any) {
            let checked;
            if (this.dirtySiteFlag.includes(dirtyValue.name)) {
                const dirtySiteFlagIndex = this.dirtySiteFlag.indexOf(dirtyValue.name);
                this.dirtySiteFlag.splice(dirtySiteFlagIndex, 1);
                checked = false;
            } else {
                this.dirtySiteFlag.push(dirtyValue.name);
                checked = true;
            }
            const dirtyEvent = {
                target: {
                    value: dirtyValue.name,
                    checked,
                },
            };
            this.updateSelection(dirtyEvent);
        }

        public dropdownAllSitesItemClick(dirtyValue: any) {
            this.dirtyAllSiteFlag = !this.dirtyAllSiteFlag;
            const dirtyEvent = {
                target: {
                    value: dirtyValue,
                    checked: this.dirtyAllSiteFlag,
                },
            };
            this.updateSelection(dirtyEvent);
        }

    }
</script>
<style lang="scss" module>
    .deletebtn {
        color: #21B5EA;
        padding: 15px;
        position: relative;
        top: 2rem;
    }
    .participantIndex {
        color: #444F51;
        font-weight: bold;
        padding-bottom: 10px;
    }
    .bField .label {
        color: #9F9F9F;
        font-size: 14px;
    }
    .applyMargin {
        margin-left: -2px;
    }
</style>
